import { createSlice } from "@reduxjs/toolkit";

//CONSTANTS
export const SELECTED_PROJECT = "selectedProject";
export const PROJECT_LIST = "projectList";
export const CHECK_PROJECT = "checkProject";
export const SUPER_USER_DETAILS = "superUserDetails";
export const USER_DETAILS = "userDetails";
export const ALL_SUPER_USERS = "allSuperUsers";
export const ALL_PROJECT_USERS = "allProjectUsers";
export const PH_REVIEWS_INFO = "phReviewsInfo";
export const PH_REVIEWS_MARKUPS = "phReviewsMarkups";
export const ALL_DOCS = "allDocs";
export const CLOUD_FILES = "cloudFiles";
export const LEGACY_MODELS = "legacyModels";
export const PENDING_CHECKLIST_DATA = "pendingChecklistsData";
export const PERSONAL_HUB_NOTIFICATIONS = "persHubNotifications";
export const ACC_DRAWING_SETS = "accDrawingSets";
export const ACC_SHEETS = "accSheets";
export const REVIEWER_ROLES = "reviewerRoles";
export const APPROVER_ROLES = "approverRoles";
export const ALL_REGIONS = "allRegions";
export const HAZOP_DATA = "hazopData";
export const SELECTED_HAZOP = "selectedHazop";
export const ADD_ENTRY_SHOW = "addEntryShow";
export const HAZOP_VIEW_MODAL = "hazopViewModal";
export const HAZOP_DUPLICATE_MODAL = "hazopDuplicateModal";
export const ALL_ROLES = "allRoles";
export const ALL_PROJECT_SUBMITTALS = "allProjectSubmittals";
export const ALL_PROJECT_REVIEWS = "allProjectReviews";
export const ALL_USER_SUBMITTALS = "allUserSubmittals";
export const AUTH_TIMER = "authTimer";
export const REGIONAL_STATUSES = "regionalStatuses";
export const SELECTED_CHECKLIST = "selectedChecklist";
export const MAINTENANCE_DATA = "maintenanceData";
export const ALL_SURVEYS = "allSurveys";
export const ALL_ASSETS = "allAssets";
export const NUMBER_OF_LOADED_GLOBAL_MODELS = "numberOfLoadedGlobalModels";
export const TOTAL_GLOBAL_MODELS = "totalGlobalModels";
export const SHOW_TOAST = "showToast";
export const TOAST_TITLE = "toastTitle";
export const TOAST_BODY = "toastBody";
export const SHEET_UPDATE_INFO = "sheetUpdateInfo";
export const PROJECT_CHANGE_LOADING = "projectChangeLoading";

//INITIAL STATE OBJECT
const initialState = {
  [SELECTED_PROJECT]: "",
  [PROJECT_LIST]: null,
  [CHECK_PROJECT]: "",
  [SUPER_USER_DETAILS]: null,
  [USER_DETAILS]: null,
  [ALL_SUPER_USERS]: [],
  [ALL_PROJECT_USERS]: [],
  [PH_REVIEWS_INFO]: {},
  [PH_REVIEWS_MARKUPS]: [],
  [ALL_DOCS]: [],
  [CLOUD_FILES]: [],
  [LEGACY_MODELS]: [],
  [PENDING_CHECKLIST_DATA]: null,
  [PERSONAL_HUB_NOTIFICATIONS]: {
    total: 0,
    numberOfChecks: 0,
    numberOfReviews: 0,
    numberOfApprovals: 0,
    numberOfMarkups: 0,
    numberOfSupSubmittals: 0,
    numberOfResSubmittals: 0,
  },
  [ACC_DRAWING_SETS]: [],
  [ACC_SHEETS]: [],
  [REVIEWER_ROLES]: [],
  [APPROVER_ROLES]: [],
  [ALL_REGIONS]: [],
  [HAZOP_DATA]: null,
  [ADD_ENTRY_SHOW]: false,
  [HAZOP_VIEW_MODAL]: false,
  [HAZOP_DUPLICATE_MODAL]: false,
  [ALL_ROLES]: [],
  [ALL_PROJECT_SUBMITTALS]: null,
  [ALL_PROJECT_REVIEWS]: null,
  [ALL_USER_SUBMITTALS]: null,
  [AUTH_TIMER]: null,
  [REGIONAL_STATUSES]: [],
  [SELECTED_CHECKLIST]: null,
  [MAINTENANCE_DATA]: null,
  [ALL_SURVEYS]: null,
  [ALL_ASSETS]: null,
  [NUMBER_OF_LOADED_GLOBAL_MODELS]: 0,
  [TOTAL_GLOBAL_MODELS]: [],
  [SHOW_TOAST]: false,
  [TOAST_TITLE]: "",
  [TOAST_BODY]: "",
  [SHEET_UPDATE_INFO]: null,
  [PROJECT_CHANGE_LOADING]: false,
};

export const globalSlice = createSlice({
  name: "globalReducer",
  initialState: initialState,
  reducers: {
    updateGlobalState: (state, action) => {
      // state[action.payload.stateName] = action.payload.value;
      return {
        ...state,
        [action.payload.stateName]: action.payload.value,
      };
    },
  },
});

export const { updateGlobalState } = globalSlice.actions;

export const globalReducer = globalSlice.reducer;
